import { render, staticRenderFns } from "./CryptoAccount.vue?vue&type=template&id=809ebe42&scoped=true&"
import script from "./CryptoAccount.vue?vue&type=script&lang=ts&"
export * from "./CryptoAccount.vue?vue&type=script&lang=ts&"
import style0 from "./CryptoAccount.vue?vue&type=style&index=0&id=809ebe42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "809ebe42",
  null
  
)

export default component.exports